import { render, staticRenderFns } from "./NoticiasView.vue?vue&type=template&id=bcc6137e&"
import script from "./NoticiasView.vue?vue&type=script&lang=ts&"
export * from "./NoticiasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports